export default function formatVimeoThumbnailUrl(originalUrl, imageSize) {
  if (originalUrl.includes('_')) {
    const baseUrl = originalUrl.split('_')[0];
    return [baseUrl, imageSize].join('_');
  } else {
    return originalUrl;
  }
}
